<div class="fixed top-20 right-4 z-[10000] space-y-2">
  <div *ngFor="let message of messages" 
       class="max-w-xs transform transition-all duration-300 ease-in-out rounded-lg p-3 shadow-lg"
       [ngClass]="{
         'bg-red-500 text-white': message.type === 'danger',
         'bg-green-500 text-white': message.type === 'success',
         'bg-yellow-500 text-white': message.type === 'warning',
         'bg-blue-500 text-white': message.type === 'info'
       }">
    
    <div class="flex items-center space-x-2">
      <!-- Icon -->
      <div class="flex-shrink-0">
        <svg class="h-4 w-4 text-white" 
             fill="currentColor" 
             viewBox="0 0 20 20">
          <path fill-rule="evenodd" [attr.d]="getIcon(message.type)" clip-rule="evenodd"></path>
        </svg>
      </div>
      
      <!-- Message -->
      <p class="text-sm text-white leading-relaxed">{{ message.message }}</p>
    </div>
  </div>
</div> 